import React from 'react';
import Grid from '@sendgrid/style-guide-grid';
import { TextInput } from '@sendgrid/ui-components';
import PropTypes from 'prop-types';
import withProfileInputs from '../containers/withProfileInputs';

export const PersonalInfo = props => (
  <section data-role="personal-info-container">
    <div className={Grid.row} >
      <div className={Grid['col-6']}>
        <TextInput
          type="text"
          label="First Name"
          id="first-name-id"
          isRequired
          onChange={props.setFirstName}
          onBlur={props.blurFirstName}
          isValid={props.profileInputs.firstNameError === null}
          value={props.profileInputs.firstName}
          info={props.profileInputs.firstNameError}
          data-role="first-name-id"
        />
      </div>
      <div className={Grid['col-6']}>
        <TextInput
          type="text"
          label="Last Name"
          id="last-name-id"
          isRequired
          onChange={props.setLastName}
          onBlur={props.blurLastName}
          isValid={props.profileInputs.lastNameError === null}
          value={props.profileInputs.lastName}
          info={props.profileInputs.lastNameError}
          data-role="last-name-id"
        />
      </div>
    </div>
    <div className={Grid.row}>
      <div className={Grid['col-6']}>
        <TextInput
          type="text"
          label="Company Name"
          id="company-name-id"
          isRequired
          onChange={props.setCompanyName}
          onBlur={props.blurCompanyName}
          isValid={props.profileInputs.companyNameError === null}
          value={props.profileInputs.companyName}
          info={props.profileInputs.companyNameError}
          data-role="company-name-id"
        />

      </div>
      <div className={Grid['col-6']}>
        <TextInput
          type="text"
          label="Phone Number"
          id="phone-number-id"
          onChange={props.setPhoneNumber}
          onBlur={props.blurPhoneNumber}
          value={props.profileInputs.phoneNumber}
          isValid={props.profileInputs.phoneNumberError === null}
          info={props.profileInputs.phoneNumberError}
          data-role="phone-number-id"
        />
      </div>
    </div>
    { props.profileInputs.isReseller ?
      <div className={Grid.row}>
        <div className={Grid['col-12']}>
          <TextInput
            type="text"
            label="Contact Email"
            id="email-id"
            isRequired
            onChange={props.setEmail}
            onBlur={props.blurEmail}
            isValid={props.profileInputs.emailError === null}
            value={props.profileInputs.email}
            info={props.profileInputs.emailError}
            data-role="email-id"
          />
        </div>
      </div> :
      null
    }
    <div className={Grid.row}>
      <div className={Grid['col-12']}>
        <TextInput
          type="text"
          label="Company Website"
          id="website-id"
          isRequired
          onChange={props.setWebsite}
          onBlur={props.blurWebsite}
          isValid={props.profileInputs.websiteError === null}
          value={props.profileInputs.website}
          info={props.profileInputs.websiteError}
          data-role="website-id"
        />
      </div>
    </div>
  </section>
);

PersonalInfo.propTypes = {
  setFirstName: PropTypes.func.isRequired,
  setLastName: PropTypes.func.isRequired,
  setCompanyName: PropTypes.func.isRequired,
  setPhoneNumber: PropTypes.func.isRequired,
  setWebsite: PropTypes.func.isRequired,
  setEmail: PropTypes.func.isRequired,
  blurFirstName: PropTypes.func.isRequired,
  blurLastName: PropTypes.func.isRequired,
  blurCompanyName: PropTypes.func.isRequired,
  blurPhoneNumber: PropTypes.func.isRequired,
  blurWebsite: PropTypes.func.isRequired,
  blurEmail: PropTypes.func.isRequired,
  profileInputs: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    firstNameError: PropTypes.string,
    lastName: PropTypes.string.isRequired,
    lastNameError: PropTypes.string,
    companyName: PropTypes.string.isRequired,
    companyNameError: PropTypes.string,
    phoneNumber: PropTypes.string.isRequired,
    phoneNumberError: PropTypes.string,
    website: PropTypes.string.isRequired,
    websiteError: PropTypes.string,
    email: PropTypes.string,
    emailError: PropTypes.string,
    isReseller: PropTypes.bool.isRequired,
  }).isRequired,
};


export default withProfileInputs(PersonalInfo);



// WEBPACK FOOTER //
// ./src/components/PersonalInfo.jsx